var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0071 3.12458L13.8759 4.99255M13.2088 1.47897L8.15554 6.53227C7.89444 6.79301 7.71637 7.12521 7.64377 7.48699L7.177 9.82349L9.5135 9.35584C9.87527 9.28349 10.207 9.10613 10.4682 8.84495L15.5215 3.79165C15.6734 3.6398 15.7938 3.45952 15.876 3.26112C15.9582 3.06271 16.0005 2.85006 16.0005 2.63531C16.0005 2.42056 15.9582 2.20791 15.876 2.0095C15.7938 1.8111 15.6734 1.63082 15.5215 1.47897C15.3697 1.32712 15.1894 1.20666 14.991 1.12448C14.7926 1.0423 14.5799 1 14.3652 1C14.1504 1 13.9378 1.0423 13.7394 1.12448C13.541 1.20666 13.3607 1.32712 13.2088 1.47897V1.47897Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2355 11.5883V14.2354C14.2355 14.7034 14.0495 15.1523 13.7186 15.4832C13.3876 15.8142 12.9388 16.0001 12.4707 16.0001H2.76473C2.29669 16.0001 1.84783 15.8142 1.51688 15.4832C1.18593 15.1523 1 14.7034 1 14.2354V4.52938C1 4.06134 1.18593 3.61248 1.51688 3.28153C1.84783 2.95057 2.29669 2.76465 2.76473 2.76465H5.41182",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.8ac7429070b3487e1f05f460e1a35374.svg";
export { ForwardRef as ReactComponent };